module.exports = __webpack_public_path__ + "assets/img/sh1.074e315a.jpg";